import { ValidatorRunner } from './models';
import * as VS from '../helpers/validators.helpers';

export const UniquenessValidator: ValidatorRunner = {
  name: 'UniquenessValidator',
  message: 'errors.UniquenessValidator',
  order: 2,
  validate({ options, formScope }) {
    if (VS.shouldNotBeExecuted(options, formScope)) return true;
    return true;
  },
};
